import getFieldOneCard from './getFieldOneCard';

export default function getFieldsForCards(
  offer,
  contentDetails,
  section,
  states,
  stateInteractions
) {
  // prettier-ignore
  return section.children.map(
    card => getFieldOneCard(offer, contentDetails, card, states, stateInteractions)
  );
}
